module.exports = "/assets/landing-rc/festival/pattern-rw.png?ErJMobd";